import * as React from "react";
const SvgFiRrCommentCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comment-check_svg__a)">
      <path
        fill="#062147"
        d="M10.5 17a2 2 0 0 1-1.416-.587L5.3 12.714a1 1 0 1 1 1.4-1.43l3.793 3.707 6.806-6.7a1 1 0 0 1 1.4 1.424l-6.793 6.707A1.99 1.99 0 0 1 10.5 17M24 19v-6.66A12.21 12.21 0 0 0 12.836.026 12 12 0 0 0 .029 12.853C.47 19.207 6.082 24 13.083 24H19a5.006 5.006 0 0 0 5-5M12.7 2.022A10.2 10.2 0 0 1 22 12.34V19a3 3 0 0 1-3 3h-5.917C7.049 22 2.4 18.1 2.025 12.715A10 10 0 0 1 12.7 2.023"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comment-check_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCommentCheck;
